'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': 'access accessibility',
  'access-ad': 'access ad',
  'access-assist-listening': 'access assist listening',
  'access-braille': 'access braille',
  'access-sign': 'access sign',
  'access-tty': 'access tty',
  'access-volume-control': 'access volume control',
  'access-wheelchair-active': 'access wheelchair active',
  'access-wheelchair': 'access wheelchair',
  'achievement': 'achievement',
  'action': 'action',
  'actions': 'actions',
  'add-circle': 'add circle',
  'add': 'add',
  'aggregate': 'aggregate',
  'aid': 'aid',
  'alarm': 'alarm',
  'alert': 'alert',
  'analytics': 'analytics',
  'announce': 'announce',
  'apps': 'apps',
  'archive': 'archive',
  'article': 'article',
  'ascend': 'ascend',
  'attachment': 'attachment',
  'back-ten': 'back ten',
  'bar-chart': 'bar chart',
  'basket': 'basket',
  'blog': 'blog',
  'book': 'book',
  'bookmark': 'bookmark',
  'bottom-corner': 'bottom corner',
  'brand-apple-app-store': 'brand apple app store',
  'brand-codepen-edit': 'brand codepen edit',
  'brand-codepen-try': 'brand codepen try',
  'brand-google-play': 'brand google play',
  'brand-grommet-outline': 'brand grommet outline',
  'brand-grommet-path': 'brand grommet path',
  'brand-hpe-element-outline': 'brand hpe element outline',
  'brand-hpe-element-path': 'brand hpe element path',
  'brand-hpe-labs-insignia-outline': 'brand hpe labs insignia outline',
  'brand-hpe-labs-insignia': 'brand hpe labs insignia',
  'brand-hpe-stack-centered': 'brand hpe stack centered',
  'brand-hpe-stack': 'brand hpe stack',
  'briefcase': 'briefcase',
  'brush': 'brush',
  'bug': 'bug',
  'bundle': 'bundle',
  'business-service': 'business service',
  'calculator': 'calculator',
  'calendar': 'calendar',
  'camera': 'camera',
  'capacity': 'capacity',
  'car': 'car',
  'caret-down': 'caret down',
  'caret-next': 'caret next',
  'caret-previous': 'caret previous',
  'caret-up': 'caret up',
  'cart': 'cart',
  'catalog': 'catalog',
  'chapter-add': 'chapter add',
  'chapter-next': 'chapter next',
  'chapter-previous': 'chapter previous',
  'chat': 'chat',
  'checkbox-selected': 'checkbox selected',
  'checkbox': 'checkbox',
  'checkmark': 'checkmark',
  'circle-information': 'circle information',
  'circle-play': 'circle play',
  'circle-question': 'circle question',
  'clear-option': 'clear option',
  'clear': 'clear',
  'cli': 'cli',
  'clipboard': 'clipboard',
  'clock': 'clock',
  'clone': 'clone',
  'close': 'close',
  'closed-caption': 'closed caption',
  'cloud-computer': 'cloud computer',
  'cloud-download': 'cloud download',
  'cloud-software': 'cloud software',
  'cloud-upload': 'cloud upload',
  'cloud': 'cloud',
  'cluster': 'cluster',
  'code': 'code',
  'columns': 'columns',
  'compare': 'compare',
  'compass': 'compass',
  'compliance': 'compliance',
  'configure': 'configure',
  'connect': 'connect',
  'contact-info': 'contact info',
  'contact': 'contact',
  'contract': 'contract',
  'copy': 'copy',
  'credit-card': 'credit card',
  'cube': 'cube',
  'cubes': 'cubes',
  'currency': 'currency',
  'cursor': 'cursor',
  'cut': 'cut',
  'cycle': 'cycle',
  'dashboard': 'dashboard',
  'database': 'database',
  'deliver': 'deliver',
  'deploy': 'deploy',
  'descend': 'descend',
  'desktop': 'desktop',
  'detach': 'detach',
  'diamond': 'diamond',
  'directions': 'directions',
  'dislike': 'dislike',
  'document-cloud': 'document cloud',
  'document-config': 'document config',
  'document-csv': 'document csv',
  'document-download': 'document download',
  'document-excel': 'document excel',
  'document-exe': 'document exe',
  'document-image': 'document image',
  'document-locked': 'document locked',
  'document-missing': 'document missing',
  'document-notes': 'document notes',
  'document-outlook': 'document outlook',
  'document-pdf': 'document pdf',
  'document-performance': 'document performance',
  'document-ppt': 'document ppt',
  'document-rtf': 'document rtf',
  'document-sound': 'document sound',
  'document-store': 'document store',
  'document-test': 'document test',
  'document-threat': 'document threat',
  'document-time': 'document time',
  'document-transfer': 'document transfer',
  'document-txt': 'document txt',
  'document-update': 'document update',
  'document-upload': 'document upload',
  'document-user': 'document user',
  'document-verified': 'document verified',
  'document-video': 'document video',
  'document-windows': 'document windows',
  'document-word': 'document word',
  'document-zip': 'document zip',
  'document': 'document',
  'domain': 'domain',
  'down': 'down',
  'download': 'download',
  'drag': 'drag',
  'drive-cage': 'drive cage',
  'duplicate': 'duplicate',
  'edit': 'edit',
  'eject': 'eject',
  'empty-circle': 'empty circle',
  'expand': 'expand',
  'fan': 'fan',
  'fast-forward': 'fast forward',
  'favorite': 'favorite',
  'filter': 'filter',
  'finger-print': 'finger print',
  'flag': 'flag',
  'folder-cycle': 'folder cycle',
  'folder-open': 'folder open',
  'folder': 'folder',
  'form-edit': 'form edit',
  'forward-ten': 'forward ten',
  'gallery': 'gallery',
  'gamepad': 'gamepad',
  'gift': 'gift',
  'globe': 'globe',
  'grid': 'grid',
  'group': 'group',
  'grow': 'grow',
  'halt': 'halt',
  'help': 'help',
  'history': 'history',
  'home': 'home',
  'host-maintenance': 'host maintenance',
  'host': 'host',
  'image': 'image',
  'impact': 'impact',
  'in-progress': 'in progress',
  'inbox': 'inbox',
  'indicator': 'indicator',
  'info': 'info',
  'inherit': 'inherit',
  'inspect': 'inspect',
  'install': 'install',
  'integration': 'integration',
  'iteration': 'iteration',
  'java': 'java',
  'language': 'language',
  'launch': 'launch',
  'layer': 'layer',
  'license': 'license',
  'like': 'like',
  'line-chart': 'line chart',
  'link-bottom': 'link bottom',
  'link-down': 'link down',
  'link-next': 'link next',
  'link-previous': 'link previous',
  'link-top': 'link top',
  'link-up': 'link up',
  'link': 'link',
  'local': 'local',
  'location-pin': 'location pin',
  'location': 'location',
  'lock': 'lock',
  'login': 'login',
  'logout': 'logout',
  'magic': 'magic',
  'mail-option': 'mail option',
  'mail': 'mail',
  'manual': 'manual',
  'map-location': 'map location',
  'map': 'map',
  'menu': 'menu',
  'microphone': 'microphone',
  'money': 'money',
  'monitor': 'monitor',
  'more': 'more',
  'multiple': 'multiple',
  'navigate': 'navigate',
  'new-window': 'new window',
  'new': 'new',
  'next': 'next',
  'nodes': 'nodes',
  'note': 'note',
  'notes': 'notes',
  'notification': 'notification',
  'object-group': 'object group',
  'object-ungroup': 'object ungroup',
  'optimize': 'optimize',
  'organization': 'organization',
  'overview': 'overview',
  'pan': 'pan',
  'pause-fill': 'pause fill',
  'pause': 'pause',
  'personal-computer': 'personal computer',
  'pie-chart': 'pie chart',
  'pin': 'pin',
  'plan': 'plan',
  'platform-amazon': 'platform amazon',
  'platform-android': 'platform android',
  'platform-apple': 'platform apple',
  'platform-archlinux': 'platform archlinux',
  'platform-aruba': 'platform aruba',
  'platform-centos': 'platform centos',
  'platform-chrome': 'platform chrome',
  'platform-cloudlinux': 'platform cloudlinux',
  'platform-debian': 'platform debian',
  'platform-docker': 'platform docker',
  'platform-dos': 'platform dos',
  'platform-dropbox': 'platform dropbox',
  'platform-dxc': 'platform dxc',
  'platform-edge': 'platform edge',
  'platform-fedora': 'platform fedora',
  'platform-firefox': 'platform firefox',
  'platform-freebsd': 'platform freebsd',
  'platform-google': 'platform google',
  'platform-hadoop': 'platform hadoop',
  'platform-heroku': 'platform heroku',
  'platform-horton': 'platform horton',
  'platform-hp': 'platform hp',
  'platform-hpi': 'platform hpi',
  'platform-internet-explorer': 'platform internet explorer',
  'platform-java': 'platform java',
  'platform-mandriva': 'platform mandriva',
  'platform-mysql': 'platform mysql',
  'platform-norton': 'platform norton',
  'platform-onedrive': 'platform onedrive',
  'platform-opera': 'platform opera',
  'platform-oracle': 'platform oracle',
  'platform-pied-piper': 'platform pied piper',
  'platform-raspberry': 'platform raspberry',
  'platform-reactjs': 'platform reactjs',
  'platform-redhat': 'platform redhat',
  'platform-safari-option': 'platform safari option',
  'platform-safari': 'platform safari',
  'platform-sco': 'platform sco',
  'platform-solaris': 'platform solaris',
  'platform-suse': 'platform suse',
  'platform-swift': 'platform swift',
  'platform-turbolinux': 'platform turbolinux',
  'platform-ubuntu': 'platform ubuntu',
  'platform-unixware': 'platform unixware',
  'platform-vmware': 'platform vmware',
  'platform-windows-legacy': 'platform windows legacy',
  'platform-windows': 'platform windows',
  'play-fill': 'play fill',
  'play': 'play',
  'power': 'power',
  'previous': 'previous',
  'print': 'print',
  'radial-selected': 'radial selected',
  'radial': 'radial',
  'refresh': 'refresh',
  'resources': 'resources',
  'resume': 'resume',
  'revert': 'revert',
  'rewind': 'rewind',
  'risk': 'risk',
  'robot': 'robot',
  'rss': 'rss',
  'run': 'run',
  'satellite': 'satellite',
  'save': 'save',
  'scan': 'scan',
  'schedule-new': 'schedule new',
  'schedule-play': 'schedule play',
  'schedule': 'schedule',
  'schedules': 'schedules',
  'scorecard': 'scorecard',
  'search-advanced': 'search advanced',
  'search': 'search',
  'secure': 'secure',
  'select': 'select',
  'selection': 'selection',
  'send': 'send',
  'server-cluster': 'server cluster',
  'server': 'server',
  'servers': 'servers',
  'service-play': 'service play',
  'services': 'services',
  'settings-option': 'settings option',
  'share': 'share',
  'shield-security': 'shield security',
  'shield': 'shield',
  'shift': 'shift',
  'sidebar': 'sidebar',
  'social-amazon': 'social amazon',
  'social-amex': 'social amex',
  'social-bitcoin': 'social bitcoin',
  'social-codepen': 'social codepen',
  'social-creative-commons': 'social creative commons',
  'social-dropbox': 'social dropbox',
  'social-facebook-option': 'social facebook option',
  'social-facebook': 'social facebook',
  'social-github': 'social github',
  'social-google-plus': 'social google plus',
  'social-google-wallet': 'social google wallet',
  'social-instagram': 'social instagram',
  'social-linkedin-option': 'social linkedin option',
  'social-linkedin': 'social linkedin',
  'social-mail': 'social mail',
  'social-mastercard': 'social mastercard',
  'social-medium': 'social medium',
  'social-paypal': 'social paypal',
  'social-pinterest': 'social pinterest',
  'social-product-hunt': 'social product hunt',
  'social-reddit': 'social reddit',
  'social-skype': 'social skype',
  'social-slack': 'social slack',
  'social-snapchat': 'social snapchat',
  'social-square': 'social square',
  'social-stack-overflow': 'social stack overflow',
  'social-stripe': 'social stripe',
  'social-tumblr': 'social tumblr',
  'social-twitter': 'social twitter',
  'social-vimeo': 'social vimeo',
  'social-vine': 'social vine',
  'social-visa': 'social visa',
  'social-wordpress': 'social wordpress',
  'social-youtube': 'social youtube',
  'sort': 'sort',
  'split': 'split',
  'splits': 'splits',
  'stakeholder': 'stakeholder',
  'standards-3d-effects': 'standards 3d effects',
  'standards-connectivity': 'standards connectivity',
  'standards-css3': 'standards css3',
  'standards-device': 'standards device',
  'standards-fireball': 'standards fireball',
  'standards-html5': 'standards html5',
  'standards-multimedia': 'standards multimedia',
  'standards-offline-storage': 'standards offline storage',
  'standards-performance': 'standards performance',
  'standards-sematics': 'standards sematics',
  'star-half': 'star half',
  'star': 'star',
  'steps': 'steps',
  'stop-fill': 'stop fill',
  'stop': 'stop',
  'storage': 'storage',
  'street-view': 'street view',
  'subtract-circle': 'subtract circle',
  'subtract': 'subtract',
  'support': 'support',
  'sync': 'sync',
  'system': 'system',
  'table-add': 'table add',
  'table': 'table',
  'tag': 'tag',
  'target': 'target',
  'task': 'task',
  'tasks': 'tasks',
  'technology': 'technology',
  'template': 'template',
  'terminal': 'terminal',
  'test-desktop': 'test desktop',
  'test': 'test',
  'text-wrap': 'text wrap',
  'threats': 'threats',
  'ticket': 'ticket',
  'tools': 'tools',
  'tooltip': 'tooltip',
  'top-corner': 'top corner',
  'transaction': 'transaction',
  'trash': 'trash',
  'tree': 'tree',
  'trigger': 'trigger',
  'trophy': 'trophy',
  'troubleshoot': 'troubleshoot',
  'unlink': 'unlink',
  'unlock': 'unlock',
  'up': 'up',
  'update': 'update',
  'upgrade': 'upgrade',
  'upload': 'upload',
  'user-add': 'user add',
  'user-admin': 'user admin',
  'user-expert': 'user expert',
  'user-female': 'user female',
  'user-manager': 'user manager',
  'user-new': 'user new',
  'user-police': 'user police',
  'user-settings': 'user settings',
  'user-worker': 'user worker',
  'user': 'user',
  'validate': 'validate',
  'video': 'video',
  'view': 'view',
  'virtual-machine': 'virtual machine',
  'vm-maintenance': 'vm maintenance',
  'volume-low': 'volume low',
  'volume-mute': 'volume mute',
  'volume': 'volume',
  'vulnerability': 'vulnerability',
  'waypoint': 'waypoint',
  'workshop': 'workshop',
  'zoom-in': 'zoom in',
  'zoom-out': 'zoom out'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/en-US.js
// module id = 56
// module chunks = 0